import React from "react";
import { Tooltip } from "antd";
import { MailOutlined, MessageOutlined, WechatWorkOutlined } from "@ant-design/icons";
import { formatMessageType } from "../../../utils/formatters";
import { MESSAGE_TYPES } from "./engagementHelpers";

const MESSAGE_TYPE_ICONS = {
  [MESSAGE_TYPES.WEBCHAT_WIDGET]: WechatWorkOutlined,
};

const getMessageIcon = (messageType, iconClassName) => {
  const IconComponent = MESSAGE_TYPE_ICONS[messageType];
  return IconComponent ? <IconComponent className={iconClassName} /> : null;
};

const MessageTypeLabel = ({
  messageType,
  children,
  placement = "top",
  defaultIcon = "message",
  iconClassName = "text-grey-500",
  containerClassName = "",
  showTooltip = true,
}) => {
  const icon =
    getMessageIcon(messageType, iconClassName) ||
    children ||
    (defaultIcon === "mail" ? (
      <MailOutlined className={iconClassName} />
    ) : (
      <MessageOutlined className={iconClassName} />
    ));

  if (!showTooltip) {
    return <span className={containerClassName}>{icon}</span>;
  }

  return (
    <Tooltip title={formatMessageType(messageType)} placement={placement}>
      <span className={containerClassName}>{icon}</span>
    </Tooltip>
  );
};

export default MessageTypeLabel;
